import React from 'react';
import { Paper, Box, Typography, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

/**
 * Reusable empty state component for list pages
 * @param {React.ReactNode} icon - Icon component to display
 * @param {string} title - Main heading text
 * @param {string} subtitle - Secondary description text
 * @param {string} buttonLabel - Button text (optional)
 * @param {function} onAction - Button onClick handler (optional)
 * @param {boolean} showAddIcon - Whether to show AddIcon in button (default: false)
 */
const EmptyState = ({ 
  icon, 
  title, 
  subtitle, 
  buttonLabel, 
  onAction,
  showAddIcon = false
}) => {
  return (
    <Paper sx={{ p: 6, textAlign: 'center' }}>
      <Box sx={{ mb: 3, opacity: 0.15 }}>
        {icon}
      </Box>
      <Typography sx={{ 
        fontFamily: '"Space Grotesk", sans-serif',
        fontSize: '1.25rem',
        fontWeight: 500,
        color: 'var(--dwlf-ink-70)',
        mb: 1.5,
      }}>
        {title}
      </Typography>
      <Typography sx={{ 
        fontFamily: '"IBM Plex Mono", monospace',
        fontSize: '0.85rem',
        color: 'var(--dwlf-ink-40)',
        mb: 4,
      }}>
        {subtitle}
      </Typography>
      {buttonLabel && onAction && (
        <Button
          variant="contained"
          startIcon={showAddIcon ? <AddIcon /> : null}
          onClick={onAction}
          sx={{ 
            fontFamily: '"Space Mono", monospace',
            fontSize: '0.75rem',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            borderRadius: 0,
            backgroundColor: 'var(--dwlf-accent)',
            color: 'var(--dwlf-bg)',
            px: 3,
            py: 1.5,
            '&:hover': { backgroundColor: 'var(--dwlf-text)' },
          }}
        >
          {buttonLabel}
        </Button>
      )}
    </Paper>
  );
};

export default EmptyState;
